"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTRPCClient = void 0;
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var client_1 = require("@trpc/client");
var httpBatchLink_1 = require("@trpc/client/links/httpBatchLink");
var httpLink_1 = require("@trpc/client/links/httpLink");
var consola_1 = __importStar(require("consola"));
var superjson_1 = __importDefault(require("superjson"));
var fetch_1 = require("../fetch");
var logger_1 = require("./links/logger");
superjson_1.default.registerCustom({
    isApplicable: function (v) { return (0, string_formatters_1.isCalendarDate)(v); },
    serialize: function (v) { return v.toString(); },
    deserialize: function (v) { return new string_formatters_1.CalendarDate(v); },
}, 'CalendarDate');
/**
 * Create a new trpc client that can be used to make requests. This is a wrapper
 * around @trpc/client that adds logging, analytics, and the authorization header.
 */
function createTRPCClient(options) {
    var getToken = options.getToken, url = options.url, _a = options.logLevel, logLevel = _a === void 0 ? consola_1.LogLevel.Error : _a, _b = options.batching, batching = _b === void 0 ? false : _b, timeoutInMilliseconds = options.timeoutInMilliseconds;
    // TODO: Any error logs should go to Sentry.
    var logger = consola_1.default.create({
        defaults: {
            message: 'TRPC',
        },
        level: logLevel,
    });
    logger.debug('Creating a new trpc client', options);
    var links = [
        (0, logger_1.loggerLink)({
            enabled: true,
            logger: logger,
        }),
        batching ? (0, httpBatchLink_1.httpBatchLink)({ url: url }) : (0, httpLink_1.httpLink)({ url: url }),
    ];
    return (0, client_1.createTRPCClient)({
        transformer: superjson_1.default,
        links: links,
        fetch: (0, fetch_1.createFetch)({
            getToken: getToken,
            throwOnError: true,
            timeoutInMilliseconds: timeoutInMilliseconds,
        }),
    });
}
exports.createTRPCClient = createTRPCClient;
